import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rolled-tag" }
const _hoisted_2 = { class: "rolled-tag__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.filter.name), 1),
    _createElementVNode("div", {
      class: "rolled-tag__delete",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deselect', _ctx.filter.id, _ctx.filter.type)))
    }, _hoisted_4)
  ]))
}